import { ApiProperty } from '@nestjs/swagger';
import { IsObject } from 'class-validator';
import { BaseActivityAIDto } from './base-activity-ai.dto';

/**
 * DTO pour créer une activité à partir d'un contenu IA pré-validé
 * Hérite de BaseActivityAIDto mais ajoute le champ content obligatoire
 */
export class ApproveActivityFromAIDto extends BaseActivityAIDto {
  @ApiProperty({
    description: "Contenu de l'activité validé par l'utilisateur",
    example: {
      questions: [{ text: 'Quelle est la moitié de 10?', answer: '5' }],
    },
  })
  @IsObject()
  content!: any;
}
